import { FC } from 'react';
import { ApiServicesContext } from './ApiServicesContext';
import { TheBoatDbApiProvider } from './TheBoatDbApiProvider';
import { TypedOpenApiProvider } from './TypedOpenApiProvider';
import { ApiServicesProviderProps } from './types';

export const ApiServicesProvider: FC<ApiServicesProviderProps> = ({ children, ...rest }) => {
  return (
    <ApiServicesContext.Provider value={rest}>
      <TypedOpenApiProvider getToken={rest.getToken} restApiServiceUrl={rest.laravelRestApiServiceUrl}>
        <TheBoatDbApiProvider apiUrl={rest.theBoatDbApiUrl}>{children}</TheBoatDbApiProvider>
      </TypedOpenApiProvider>
    </ApiServicesContext.Provider>
  );
};
